import { render, staticRenderFns } from "./product-segment.vue?vue&type=template&id=5eaa759c&scoped=true&"
import script from "./product-segment.vue?vue&type=script&lang=js&"
export * from "./product-segment.vue?vue&type=script&lang=js&"
import style0 from "./product-segment.vue?vue&type=style&index=0&id=5eaa759c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaa759c",
  null
  
)

export default component.exports